const GOOGLE_SCRIPT_URL =
  'https://script.google.com/macros/s/AKfycbwctXQbA5B_t-Y5XOav-aTIYx1U7M9zdP7-mFIH-uzgHJ_C_9Kin5nDP4WhUoXbd_-OrQ/exec'

export interface ApplicationPayload {
  name: string
  contact: string
  social: string
  whyFit?: string
  source: string
  userAgent: string
}

export async function submitToGoogleSheets(
  data: ApplicationPayload,
): Promise<{ success: boolean; error?: string }> {
  try {
    await fetch(GOOGLE_SCRIPT_URL, {
      method: 'POST',
      mode: 'no-cors', // Required for Google Apps Script
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })

    // With no-cors, we can't read the response, so we assume success if no error thrown
    return { success: true }
  } catch (error) {
    console.error('Error submitting to Google Sheets:', error)
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error occurred',
    }
  }
}
